// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/spinner.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XhTJRsDNqkahHm.s_FTT1Qq1Zyd9Q.lm7ZCKhqNElhRo {
  text-align: center;
}
.XhTJRsDNqkahHm.s_FTT1Qq1Zyd9Q > .JdNgEHk1LXbnmP {
  margin: var(--ds-space-0, 0) auto;
}
.XhTJRsDNqkahHm.lm7ZCKhqNElhRo > .JdNgEHk1LXbnmP {
  display: inline-block;
  vertical-align: middle;
}
.JdNgEHk1LXbnmP {
  display: block;
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 30px 30px;
}
.JdNgEHk1LXbnmP.vrbiU35RImXc9P {
  background: linear-gradient(135deg, #0065ff 0%, #bf63f3 50%, #ffa900 100%);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: 30px;
}
.JdNgEHk1LXbnmP.p4nagF1N43na7P {
  width: 18px;
  height: 18px;
  background-size: 18px 18px;
}
.JdNgEHk1LXbnmP.p4nagF1N43na7P.vrbiU35RImXc9P {
  mask-size: 18px;
}
.JdNgEHk1LXbnmP.bZwYUrs7dnRdT4 {
  margin-right: var(--ds-space-050, 3px);
}
`, ""]);
// Exports
export var wrapper = `XhTJRsDNqkahHm`;
export var centered = `s_FTT1Qq1Zyd9Q`;
export var inline = `lm7ZCKhqNElhRo`;
export var spinner = `JdNgEHk1LXbnmP`;
export var aiSpinner = `vrbiU35RImXc9P`;
export var small = `p4nagF1N43na7P`;
export var modLeft = `bZwYUrs7dnRdT4`;
export default ___CSS_LOADER_EXPORT___;
